import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar, IonCol, IonRow, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonGrid, useIonViewDidEnter } from '@ionic/react';
import { useParams } from 'react-router';
import ExploreContainer from '../components/ExploreContainer';
import { Descriptions, Row, Col, notification, Tag, Modal } from 'antd';
import { Card } from 'antd';
import { Switch } from 'antd';
import { Input } from 'antd';
import moment from 'moment';
import { PageHeader } from 'antd';
import './Page2.css';
import { makeStyles } from '@mui/material/styles';
import Button from '@mui/material/Button';
import { DatePicker, Space } from 'antd';
import Highlighter from 'react-highlight-words';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import ReactDOM from "react-dom";
import createRowData from "../components/createRowData";
import { SearchOutlined } from '@ant-design/icons';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useDemoData } from '@mui/x-data-grid-generator';
import { DataGrid, GridCellParams, GridToolbar } from '@mui/x-data-grid';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { UIStore } from "../store/store";
import { Backdrop } from '@mui/material';
// declare module 'react-data-grid-addons

const Listings: React.FC = (props: any) => {
  
  const useStyles = makeStyles((theme) => ({
    backdrop: {
      background: "black",
      zIndex: theme.zIndex.drawer + 1,
      color: "#fff",
    },
    }));
   //fetching from store(PullState)
   const currentListing = UIStore.useState(s => s.SelectedListings);

  const [oringalListing,setOrginalListing] =useState([])
  const [enteredstatus, setEnteredStatus] = useState('');
  const [currentListings, setCurrentListing] = useState({});
  const [isModalStatusVisible, setIsStatusModalVisible] = useState(false);

  const handleStatusOk = () => {
    setIsStatusModalVisible(false);
    UpdateListing();
  };

  const showStatusModal = () => {
    setIsStatusModalVisible(true);
  };

  const statusChangeHandler = (event:any, Listing: any) => {
    setEnteredStatus(event.target.value);
    let index = oringalListing.findIndex((ogListing) => ogListing['PropertyID']['id'] === Listing.id)
    setCurrentListing(oringalListing[index]);
    showStatusModal();
    
};

const classes = useStyles();

  const columns = [

    { field: 'Name', headerName: 'NAME', width: 170 },
    { field: 'created', headerName: 'CREATED', width: 170 },
    { field: 'MonthlyRent', headerName: 'RENT', width: 170 },
    { field: 'Address', headerName: 'ADDRESS', width: 170 },
    { field: 'numberofrooms', headerName: '#ROOMS', width: 170 },
    { field: 'Description', headerName: 'DESCRIPTION', width: 170 },
    { field: 'FurnishedType', headerName: 'FURNITURE', width: 170 },
    { field: 'PropertyType', headerName: 'TYPE', width: 170 },
    {
      field: 'Status', headerName: 'STATUS', width: 190,
      renderCell: (params: GridCellParams) => (<strong>
          <Select
            labelId="demo-simple-select-label"
            style = {{width:"180px"}}
            onChange={(e) => statusChangeHandler(e, params.row)}
            value={params.value}
          >
            <MenuItem value={"Active"}>Active</MenuItem>
            <MenuItem value={"Inactive"}>Inactive</MenuItem>
          </Select>
        </strong>),
    },
    {
      field: 'details', headerName: 'DETAILS', width: 190,
      renderCell: (params:any) => {
      return(
      <strong>
       <Link to={{ pathname: "/ListingsDetails"}}  >
          <Button
            variant="contained"
            color="primary"
            size="small"    
              onClick={() => {
              console.log(params.row)
               //updating the store(PullState) Property value           
                 /* @ts-ignore */
                // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                let temp:any = oringalListing.find((lis) => lis.PropertyID.id === params.row.id);
                 /* @ts-ignore */
                console.log(temp)
              UIStore.update((s, o) => {
                s.SelectedListings = temp;
              });
            }}       
            style={{ marginLeft: 25 }} > View Details </Button>       
       </Link>
             </strong>)},
    },

  ];

  const [data, SetData] = useState([]);

  const [open, setOpen] = useState(true);

  const handleBackDropClose = () => {
    setOpen(false);
  };

 useIonViewDidEnter(() => {

  axios.get('https://dev.northroom.co.za/api/bizprop/listings/all')
    .then(function (response) {
      // handle success
      let tempStatus = response.data.map((listing: { Status: any; }) => listing.Status)
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      let tempPropertyID = response.data.map((listing: { PropertyID: any; }) => listing.PropertyID)
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      let temp = tempPropertyID.map((Property: any, index: any) => ({ ...Property, Status: tempStatus[index] }))
      console.log(response.data)
      SetData(temp);
      setOrginalListing(response.data);
      handleBackDropClose();
  })
  .catch(function (error) {
    // handle error
    console.log(error);
  })
  .then(function () {
    // always executed
  });
  });

  useEffect(() => {
    
  }, [currentListing]);

  async function UpdateListing() {
    /* @ts-ignore */
    let tempListing = currentListings;
    /* @ts-ignore */
    tempListing.Status = enteredstatus;
    /* @ts-ignore */
    console.log(tempListing);
    
    try {
      axios({
        method: "post",
        url: "https://dev.northroom.co.za/api/bizprop/listing/update",
        data: tempListing,
      })
        .then(function (response) {
          //handle success
          console.log(response);
          axios.get('https://dev.northroom.co.za/api/bizprop/listings/all')
            .then(function (response) {
              // handle success
              let tempStatus = response.data.map((listing: { Status: any; }) => listing.Status)
              // eslint-disable-next-line @typescript-eslint/no-unused-expressions
              let tempPropertyID = response.data.map((listing: { PropertyID: any; }) => listing.PropertyID)
              // eslint-disable-next-line @typescript-eslint/no-unused-expressions
              let temp = tempPropertyID.map((Property: any, index: any) => ({ ...Property, Status: tempStatus[index] }))
              SetData(temp);
            })
            .catch(function (error) {
              // handle error
              console.log(error);
            })
            .then(function () {
              // always executed
            });
        })
        .catch(function (response) {
          //handle error
          console.log(response);
        });

    } catch (error) {
      console.error(error.response.data);
    }
    

  }

  const { name } = useParams<{ name: string; }>();

  return (

    <IonPage>
       <Backdrop
        className={classes.backdrop}
        open={open}
        transitionDuration={1500}
      ></Backdrop>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonRow>
            <PageHeader
              className="site-page-header"
              title="Listings"

            />
          </IonRow>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen >
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large">{name}</IonTitle>
          </IonToolbar>
        </IonHeader>
        <Space direction="vertical">
          <IonGrid>
            <IonRow>
              <IonCol size="11" style={{ paddingLeft: "2vw", paddingRight: "1vw" }}>
                <IonCard>
                  <IonCardHeader>
                  < Modal
                     
                      visible={isModalStatusVisible}
                      onOk={handleStatusOk}
                      cancelButtonProps={{ style: { display: 'none' } }}            
                    >
                      <Space direction="vertical">
                        {/* @ts-ignore */}
                        <p>Updated {currentListing.Name}</p>
                      </Space>
                    </Modal>
                  </IonCardHeader>

                  <IonCardContent>

                    <div style={{ height: 400, width: '80vw', paddingRight: "7.5vw" }}>
                      <DataGrid
                        /* @ts-ignore */
                        rows={data}
                        columns={columns}
                        components={{
                          Toolbar: GridToolbar,
                        }}
                        filterModel={{
                          items: [
                            { columnField: 'Name', operatorValue: 'contains', value: '' },
                          ],
                        }}
                      />
                    </div>

                  </IonCardContent>
                </IonCard>
              </IonCol>
            </IonRow>
          </IonGrid>

        </Space>
      </IonContent>
    </IonPage>

  );
};

export default Listings;